import React, { useCallback } from 'react';
import { IoIosArrowBack } from 'react-icons/io';
import { useHistory } from 'react-router-dom';

import { Container } from './styles';
import { KrClose } from '../KoroIcons';

interface IProps {
  className?: string;
  href?: string;
}

const ButtonBack: React.FC<IProps> = ({ className, href }) => {
  const history = useHistory();

  const handleBack = useCallback(() => {
    if (href) {
      history.push(href);
    } else {
      history.goBack();
    }
  }, [history, href]);

  return (
    <Container
      type="button"
      onClick={handleBack}
      className={`d-flex align-items-center border-0 ${className}`}
    >
      <KrClose color="#fff" size={40} className="" />
    </Container>
  );
};

export default ButtonBack;
